module.exports = __webpack_public_path__ + "img/logo.98173be7.png";